module.exports = __webpack_public_path__ + "assets/src/style/img/svg/icons/category-featured.svg?18e7e3a85cdf23897035e6556476b407";